<template>
  <div class="page-business-intelligence-performance">
    <BISummary :dates="dates" @on-date-changed="updateDateRange" />
    <BITenders :dates="dates" :hasTenderChanged="hasTenderChanged" @tender-clicked="onTenderClicked" />
    <TenderDetailsDialog ref="tenderDetailsDialog" :tender="selectedTender" @on-tender-changed="onTenderChanged" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import BISummary from '@/components/page-business-intelligence/BISummary.vue';
import BITenders from '@/components/page-business-intelligence/BITenders.vue';
import TenderDetailsDialog from '@/components/page-business-intelligence/TenderDetailsDialog.vue';
import { getStartOfYear, getToday } from '@/util/date-util';

export default {
  name: 'PageBIPerformance',
  components: {
    BISummary,
    BITenders,
    TenderDetailsDialog,
  },
  data() {
    return {
      dates: [getStartOfYear(), getToday()], // Default to current year
      selectedTender: null,
      hasTenderChanged: false,
    };
  },
  computed: {
    ...mapGetters('biDashboard', { savedDates: 'dates' }),
  },
  methods: {
    ...mapActions('biDashboard', ['setDates']),
    updateDateRange(dates) {
      this.setDates(dates);
      this.dates = dates;
    },
    onTenderClicked(tender) {
      this.selectedTender = tender;
      this.hasTenderChanged = false;
      this.$refs.tenderDetailsDialog.openDialog();
    },
    onTenderChanged() {
      this.hasTenderChanged = true;
    },
  },
  created() {
    if (this.savedDates && this.savedDates.length === 2) {
      this.dates = this.savedDates;
    }
  },
};
</script>

<style lang="scss">
.page-business-intelligence-performance {
  padding: 32px;

  // Phones: the screen's gutter, and a tender drawer no wider than the screen.
  @include screen-below('tablet') {
    padding: $phone-page-gutter;

    .__tender-drawer {
      min-width: 0;
    }
  }

  .__tender-drawer {
    min-width: 450px;
  }
}
</style>
